<gstar-investment-jurisdictions-grid
  [source]="investmentJurisdiction()"
  [query]="query"
  (queryChange)="queryUpdated($event)"
  (create)="create($event)"
  (update)="update($event)"
  (exportDownloadAll)="exportAllCountryInformation()"
  (exportDownload)="exportCountryInformation($event)" />
